import {
    getProductList,
} from '@/api/taskCenter';
import i18n from '@/Language';
import _ from 'lodash'

const task = {
  state: {
    productList: [],
    productObj: {},
    productModelObj: {},
    batteryValue: {
      batteryType: 0,
      batteryValue: 0,
    },
  },
  mutations: {
    SET_STATE: (state, { value, type }) => {
      state[type] = value;
    }
  },
  actions: {
    setBatteryValue({ commit }, obj = {}) {
      commit('SET_STATE', {
        value: obj,
        type: 'batteryValue',
      })
    },
    setProductList({ commit }, arr = null) {
        return new Promise((resolve, reject) => {
            const deviceTypes = '60419';
            getProductList({ deviceTypes }).then(res => {
                if (!res || typeof res !== 'object') return;
                const { success, code, data } = res
                const productObj = {}
                const productModelObj = {}
                if (success) {
                    const productList = data.map(item => {
                        productObj[item.id] = item;
                        productModelObj[item.productModel] = item;
                        return {
                            label: item.productModel,
                            value: item.id,
                        }
                    })
                    commit('SET_STATE', {
                        value: productList,
                        type: 'productList',
                    })
                    commit('SET_STATE', {
                        value: productObj,
                        type: 'productObj',
                    })
                    commit('SET_STATE', {
                        value: productModelObj,
                        type: 'productModelObj',
                    })
                    resolve({
                        productList,
                        productObj,
                        productModelObj,
                    })
                }
            }).catch(err => {
              reject(err)
            })
        })
	},
  }
}

export default task